import { AuthorizationForm } from '@/features/authorization/authorization-form/authorization-form';
import { AuthorizationTel } from '@/features/authorization/authorization-tel/authorization-tel';

/**
 * Модальное окно регистрации. 
 * 
 * Открывает модалку с сообщением об успехе, если получает от одной из вложенных форм событие formSubmit.
 *
 * Взаимодействия с сервером не предполагает, коллбэков не принимает.
 * @category 6 Авторизация
 * @example
 * window.app.registerSuccess = new Register(window.app.registerEmail, window.app.registerTel, '#modal-register-success');
 * @constructor
 * @param {AuthorizationForm} email Экземпляр класса AuthorizationForm с формой регистрации по почте. 
 * @param {AuthorizationTel} tel Экземпляр класса AuthorizationTel с формой регистрации по телефону. 
 * @param {string} modalSelector Селектор модального окна с сообщением об успешной отправке. 
 */

export class Register {
	private email: AuthorizationForm;
	private tel: AuthorizationTel;
	private readonly modalSelector: string;

	constructor(email: AuthorizationForm, tel: AuthorizationTel, modalSelector: string) {
		if (!email || !tel || !modalSelector) return;
		this.email = email;
		this.tel = tel;
		this.modalSelector = modalSelector;
		this.init();
	}

	private handleFormSubmit = (): void => window.app.modal.open(this.modalSelector);

	public init = (): void => {
		this.email.element?.addEventListener('formSubmit', this.handleFormSubmit);
		this.tel.codeElement?.addEventListener('formSubmit', this.handleFormSubmit);
	};
}
